import { app } from '../../../../../app';
import { Controller } from './group-settings.controller';

app.component('companyUserDirectoriesManageGroupSettings', {
    bindings: {
        companyId: '<',
        group: '<',
    },
    controller: Controller,
    templateUrl: require('./group-settings.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/settings/group-settings.component.js